import { Component, Input, OnInit, HostListener } from '@angular/core';
import { DemoService } from 'src/app/demo.service';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';

@Component({
  selector: 'app-system-notice-banner',
  templateUrl: './system-notice-banner.component.html',
  styleUrls: ['./system-notice-banner.component.scss']
})
export class SystemNoticeBannerComponent implements OnInit {
  @Input() currentRoute: string = '';
  notices: any[] = [];
  bannerNotices: any[] = [];
  modalNotices: any[] = [];

  constructor(
    private _demoService: DemoService,
    public gfunc: GlobalFunctionsService
  ) {}

  ngOnInit(): void {
    this.loadNotices();
  }

  loadNotices(): void {
    const dismissedIds = this.getDismissedNoticeIds();

    const payload = {
      route: this.currentRoute,
      user_id: this.gfunc.sessionUserId,
      user_level: this.gfunc.sessionUserLevel,
      brand_id: this.gfunc.sessionBrandId,
      is_login_page: this.currentRoute === 'login' ? 1 : 0
    };

    this._demoService.getSystemNoticesByRoute(payload).subscribe((res: any[]) => {
      const visibleNotices = res.filter(n => !dismissedIds.includes(n.id));
      this.bannerNotices = visibleNotices.filter(n => n.show_as_modal == 0);
      this.modalNotices = visibleNotices.filter(n => n.show_as_modal == 1);
    });
  }

  dismissNotice(id: number): void {
    const dismissed = this.getDismissedNoticeIds();
    if (!dismissed.includes(id)) {
      dismissed.push(id);
      localStorage.setItem('dismissedSystemNotices', JSON.stringify(dismissed));
    }

    this.bannerNotices = this.bannerNotices.filter(n => n.id !== id);
    this.modalNotices = this.modalNotices.filter(n => n.id !== id);
  }

  getDismissedNoticeIds(): number[] {
    const raw = localStorage.getItem('dismissedSystemNotices');
    return raw ? JSON.parse(raw) : [];
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapePress(event: KeyboardEvent) {
    this.modalNotices = [];
  }
}
